// Client-side checks copied from the desktop dialogs, so the messages match.
export const MIN_PASSWORD_LENGTH = 8;
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export type Strength = "Too short (min 8 chars)" | "Weak" | "Fair" | "Good" | "Strong";

/** signup_window.py _password_strength */
export function passwordStrength(pw: string): Strength {
  if (pw.length < 8) return "Too short (min 8 chars)";
  const upper = /\p{Lu}/u.test(pw);
  const digit = /\p{Nd}/u.test(pw);
  const special = [...pw].some((c) => "!@#$%^&*()-_=+[]{}|;':\",./<>?".includes(c));
  return (["Weak", "Fair", "Good", "Strong"] as const)[Number(upper) + Number(digit) + Number(special)];
}

export const STRENGTH_COLORS: Record<Strength, string> = {
  "Too short (min 8 chars)": "#E5484D", Weak: "#E07A3F", Fair: "#E5B454", Good: "#7CB342", Strong: "#4CAF7D",
};

/** Message for the first problem with a signup form, or null (signup_window._on_submit). */
export function signupProblem(f: { username: string; email: string; password: string; confirm: string }): string | null {
  if (!f.username.trim() || !f.email.trim() || !f.password || !f.confirm) return "All fields are required.";
  if (!EMAIL_RE.test(f.email.trim())) return "Invalid email address.";
  const s = passwordStrength(f.password);
  if (s === "Too short (min 8 chars)" || s === "Weak") return `Password is ${s.toLowerCase()}. Choose a stronger password.`;
  if (f.password !== f.confirm) return "Passwords do not match.";
  return null;
}

/** change_password_dialog._on_submit */
export function changePasswordProblem(current: string, next: string, confirm: string): string | null {
  if (!current || !next || !confirm) return "Please fill in all fields.";
  if (next.length < MIN_PASSWORD_LENGTH) return `New password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (next !== confirm) return "New password and confirmation do not match.";
  return null;
}

/** recover_password_dialog._on_submit */
export function recoverProblem(username: string, next: string, confirm: string): string | null {
  if (!username.trim()) return "Enter the username or email of the account.";
  if (next.length < MIN_PASSWORD_LENGTH) return `The new password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (next !== confirm) return "The two passwords do not match.";
  return null;
}
